module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }